import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useAuthStore } from '../../store/authStore';
import { usePermissions } from '../../hooks/usePermissions';
import type { MonthApprovalStatus } from './monthApprovalModel';

export const MONTH_APPROVAL_STATUS_KEY = ['month-approval', 'status'] as const;

/**
 * D-319 - the months I still have to approve. OTE employees only (a customer identity never asks).
 * A load failure never blocks anything (no window, no disabled buttons): the server still refuses a timer.
 */
export function useMonthApprovalStatus() {
  const user = useAuthStore((s) => s.user);
  const { isOteEmployee } = usePermissions();
  const q = useQuery({
    queryKey: MONTH_APPROVAL_STATUS_KEY,
    queryFn: () => api.getMyMonthApprovalStatus(),
    enabled: !!user && !!isOteEmployee,
    staleTime: 30_000,
    retry: false,
  });
  const status: MonthApprovalStatus | null = (q.data as any)?.data ?? null;
  return { status, pending: status?.pending ?? [], refetch: q.refetch };
}
